module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-component"
  }, [_vm._t("filters"), _vm._v(" "), _c('div', {
    staticClass: "main-list"
  }, [_vm._t("list")], 2), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('span'), _vm._v(" "), _c('span', [_vm._v("Total de Registros: "), _c('strong', [_vm._v(_vm._s(_vm.listStore.listTotal))])])]), _vm._v(" "), (_vm.isPaginationVisible) ? _c('el-pagination', {
    staticClass: "list-pagination",
    attrs: {
      "page-sizes": _vm.pages,
      "page-size": _vm.listStore.listPerPage,
      "current-page": _vm.currentPage,
      "layout": "sizes, prev, pager, next",
      "total": _vm.listStore.listTotal
    },
    on: {
      "size-change": _vm.onPaginatorChangeSize,
      "current-change": _vm.onPaginatorChangePage,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ea584b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/list/Main.vue
// module id = 725
// module chunks = 2